module.exports = __webpack_public_path__ + "img/عمودیa3.8e79deb6.jpg";